<template>
  <div class="PhoneVerificationNote" role="note" data-e2e="phoneVerificationNote">
    <svg
      class="PhoneVerificationNote__icon"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10" cy="10" r="10" fill="currentColor" />
      <path
        fill="#fff"
        d="M10 8.4a.9.9 0 0 1 .9.9v4.3a.9.9 0 1 1-1.8 0V9.3a.9.9 0 0 1 .9-.9Zm0-3.3a1.1 1.1 0 1 1 0 2.2 1.1 1.1 0 0 1 0-2.2Z"
      />
    </svg>
    <p class="PhoneVerificationNote__text">{{ $t('phone_verification.info_note') }}</p>
  </div>
</template>

<script>
// Tells the participant why the phone field is followed by Send Code (#1709)
export default {
  name: 'PhoneVerificationNote'
}
</script>

<style lang="scss" scoped>
.PhoneVerificationNote {
  @apply flex items-start gap-3 rounded-lg p-4 mb-4;
  background: #e8f1fb;
  border: 1px solid #b9d0ea;
  color: #1f3a5c;

  &__icon {
    @apply flex-shrink-0;
    margin-top: 2px;
    color: #2b6cb0;
  }
  &__text {
    @apply text-sm m-0;
  }
}
</style>
